import React from 'react';
import { Task, TaskStatus } from '../types';
import { TaskCard } from '../components/TaskCard';

interface KanbanViewProps {
  tasks: Task[];
  onUpdateStatus: (taskId: string, status: TaskStatus) => void;
  onDeleteTask: (id: string) => void;
  onFocusTask: (id: string) => void;
}

export const KanbanView: React.FC<KanbanViewProps> = ({ tasks, onUpdateStatus, onDeleteTask, onFocusTask }) => {
  const columns = [
    { id: TaskStatus.Todo, label: 'To Do' },
    { id: TaskStatus.Doing, label: 'Doing' },
    { id: TaskStatus.Done, label: 'Done' }
  ];

  const handleDrop = (e: React.DragEvent, status: TaskStatus) => {
    e.preventDefault();
    const taskId = e.dataTransfer.getData('taskId');
    if (taskId) {
      onUpdateStatus(taskId, status);
    }
  };

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
  };

  return (
    <div className="flex flex-col md:flex-row gap-4 h-full overflow-x-auto pb-2">
      {columns.map(col => {
        const colTasks = tasks.filter(t => t.status === col.id);
        
        return (
          <div 
            key={col.id}
            className="flex-1 min-w-[280px] bg-gray-100 rounded-lg p-3 flex flex-col max-h-full"
            onDrop={(e) => handleDrop(e, col.id)}
            onDragOver={handleDragOver}
          >
            <div className="flex items-center justify-between mb-3 px-1">
              <h3 className="font-semibold text-gray-700">{col.label}</h3>
              <span className="bg-gray-200 text-gray-600 px-2 py-0.5 rounded-full text-xs font-medium">
                {colTasks.length}
              </span>
            </div>
            
            <div className="flex-1 overflow-y-auto min-h-[100px] pr-1">
               {colTasks.map(task => (
                 <TaskCard 
                   key={task.id} 
                   task={task} 
                   onDelete={onDeleteTask} 
                   onFocus={onFocusTask}
                 />
               ))}
               {colTasks.length === 0 && (
                 <div className="h-24 flex items-center justify-center text-gray-400 text-sm italic">
                   Empty
                 </div>
               )}
            </div>
          </div>
        );
      })}
    </div>
  );
};